(function () {
  var root = (window.routes && window.routes.root) || '/';

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Cart drawer ---------- */
  function drawer() { return qs('[data-cart-drawer]'); }

  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshDrawer() {
    return fetch(root + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        var current = drawer();
        if (fresh && current) {
          var wasOpen = current.getAttribute('aria-hidden') === 'false';
          current.innerHTML = fresh.innerHTML;
          current.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
        }
        var count = tmp.querySelector('[data-cart-count]');
        qsa('[data-cart-count]').forEach(function (el) {
          if (count) el.textContent = count.textContent;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = qs('[data-nav]');
      if (nav) nav.classList.toggle('is-open');
      return;
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var input = step.parentNode.querySelector('input');
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        v += parseInt(step.getAttribute('data-qty-step'), 10);
        input.value = Math.max(1, v);
      }
      return;
    }

    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-remove'), 0);
      return;
    }

    var lineStep = e.target.closest('[data-line-step]');
    if (lineStep) {
      e.preventDefault();
      changeLine(lineStep.getAttribute('data-line'), parseInt(lineStep.getAttribute('data-line-qty'), 10));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function changeLine(line, quantity) {
    fetch((window.routes && window.routes.cart_change) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        refreshDrawer();
      })
      .catch(function () { window.location.reload(); });
  }

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Adding\u2026'; }

    fetch((window.routes && window.routes.cart_add) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(); })
      .then(function () { openDrawer(); })
      .catch(function () { window.location.href = (window.routes && window.routes.cart) || '/cart'; })
      .then(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.textContent = label; }
      });
  });

  /* ---------- Variant selection ---------- */
  function initVariants() {
    qsa('[data-variant-root]').forEach(function (rootEl) {
      var data = qs('[data-variant-json]', rootEl);
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (err) { return; }
      var selects = qsa('[data-option-index]', rootEl);
      var idInput = qs('[data-variant-id]', rootEl);
      var priceEl = qs('[data-variant-price]', rootEl);
      var btn = qs('[data-add-button]', rootEl);

      function update() {
        var chosen = selects.map(function (s) { return s.value; });
        var match = variants.filter(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        })[0];
        if (!match) {
          if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_formatted) priceEl.innerHTML = match.price_formatted;
        if (btn) {
          if (match.available) { btn.removeAttribute('disabled'); btn.textContent = 'Add to cart'; }
          else { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Sold out'; }
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }

  if (document.readyState !== 'loading') initVariants();
  else document.addEventListener('DOMContentLoaded', initVariants);
  document.addEventListener('shopify:section:load', initVariants);
})();
